<script lang="ts" setup>
	import ShoppingcartSubstitute from '@/components/ShoppingcartSubstitute.vue';
	import {getFormattedRegionName} from '@/service/order.line.service';
	import {getSubstitutes} from '@/service/substitute.service';
	import type {Substitute} from 'dummen-shared';
	import {onMounted, ref, type Ref} from 'vue';
	import {useI18n} from 'vue-i18n';
	import type {ShoppingCartOrderLine} from 'dummen-shared/src/interfaces/order.line.type.ts';

	const props = defineProps<{
		orderLine: ShoppingCartOrderLine;
		columns: number;
	}>();

	const {t} = useI18n();
	const loading = ref(false);
	const substitutes: Ref<Substitute[]> = ref([]);

	onMounted(async () => {
		loading.value = true;

		const region = props.orderLine.region ?? window.primaryRegion;

		if (!region) {
			loading.value = false;
			return;
		}

		const pathname = location.pathname;
		const language = pathname.split('/')[2];

		await getSubstitutes(language, getFormattedRegionName(region), props.orderLine)
			.then(response => substitutes.value = response)
			.finally(() => loading.value = false);
	});
</script>

<template>
	<tr class="substitutes--row">
		<td v-if="loading" colspan="100%">
			<p>{{ t('shoppingcart.generic.loading.text') }}</p>
		</td>

		<td v-if="orderLine && !loading" :colspan="columns">
			<div class="substitute--wrapper">
				<template v-if="substitutes?.length > 0">
					<div class="substitute--message">
						<h3>{{ t('shoppingcart.substitutes.header.text') }}</h3>
						<p>{{ t('shoppingcart.substitutes.info.text') }}</p>
					</div>

					<div class="substitutes--grid">
						<shoppingcart-substitute v-for="substitute in substitutes"
						                         :key="substitute.id"
						                         :product="substitute"
						                         :region="orderLine.region" />
					</div>
				</template>

				<div v-else class="substitute--message no-substitutes">
					<h3>{{ t('shoppingcart.no-substitutes.header.text') }}</h3>
				</div>
			</div>
		</td>
	</tr>
</template>
